export const NZ_DATA = [
  {
    industryIdFilter: -1,
    roles: [
      {
        rank: 1,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Salesperson',
        avgSalary: 84791,
        salaryGrowth: 16.4,
        jobs: 48,
      },
      {
        rank: 2,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Security Officer',
        avgSalary: 55799,
        salaryGrowth: 12.5,
        jobs: 51,
      },
      {
        rank: 3,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Animal Attendant',
        avgSalary: 52617,
        salaryGrowth: 12.5,
        jobs: 35,
      },
      {
        rank: 4,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Maintenance Technician',
        avgSalary: 73101,
        salaryGrowth: 12.2,
        jobs: 63,
      },
      {
        rank: 5,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Coach',
        avgSalary: 64872,
        salaryGrowth: 11.4,
        jobs: 41,
      },
      {
        rank: 6,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Branch Manager',
        avgSalary: 83258,
        salaryGrowth: 10,
        jobs: 66,
      },
      {
        rank: 7,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Detailer',
        avgSalary: 56636,
        salaryGrowth: 9.6,
        jobs: 36,
      },
      {
        rank: 8,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Centre Operator',
        avgSalary: 58457,
        salaryGrowth: 9.4,
        jobs: 39,
      },
      {
        rank: 9,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Draftsperson',
        avgSalary: 86886,
        salaryGrowth: 9.2,
        jobs: 35,
      },
      {
        rank: 10,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Therapist',
        avgSalary: 90817,
        salaryGrowth: 9.1,
        jobs: 146,
      },
      {
        rank: 11,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Project Engineer',
        avgSalary: 119987,
        salaryGrowth: 9.1,
        jobs: 163,
      },
      {
        rank: 12,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Centre Manager',
        avgSalary: 100173,
        salaryGrowth: 9,
        jobs: 87,
      },
      {
        rank: 13,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Dispatcher',
        avgSalary: 71138,
        salaryGrowth: 9,
        jobs: 40,
      },
      {
        rank: 14,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Commercial Analyst',
        avgSalary: 117164,
        salaryGrowth: 8.9,
        jobs: 31,
      },
      {
        rank: 15,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Inventory Controller',
        avgSalary: 68720,
        salaryGrowth: 8.9,
        jobs: 37,
      },
      {
        rank: 16,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Data Engineer',
        avgSalary: 131324,
        salaryGrowth: 8.8,
        jobs: 122,
      },
      {
        rank: 17,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Data Analyst',
        avgSalary: 98259,
        salaryGrowth: 8.7,
        jobs: 59,
      },
      {
        rank: 18,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Caretaker',
        avgSalary: 58670,
        salaryGrowth: 8.4,
        jobs: 42,
      },
      {
        rank: 19,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Systems Administrator',
        avgSalary: 93094,
        salaryGrowth: 8.3,
        jobs: 48,
      },
      {
        rank: 20,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Librarian',
        avgSalary: 70470,
        salaryGrowth: 8.3,
        jobs: 44,
      },
    ],
  },
  {
    industryIdFilter: 1202,
    roles: [
      {
        rank: 1,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Commercial Analyst',
        avgSalary: 117164,
        salaryGrowth: 8.9,
        jobs: 31,
      },
      {
        rank: 2,
        industryId: 1202,
        industryTitle: 'Accounting',
        roleTitle: 'Credit Controller',
        avgSalary: 72167,
        salaryGrowth: 3.5,
        jobs: 31,
      },
    ],
  },
  {
    industryIdFilter: 6251,
    roles: [
      {
        rank: 1,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Operations Administrator',
        avgSalary: 65157,
        salaryGrowth: 7,
        jobs: 34,
      },
      {
        rank: 2,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Accounts Administrator',
        avgSalary: 64784,
        salaryGrowth: 5,
        jobs: 42,
      },
      {
        rank: 3,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Support Coordinator',
        avgSalary: 66184,
        salaryGrowth: 4.5,
        jobs: 44,
      },
      {
        rank: 4,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Support Officer',
        avgSalary: 63250,
        salaryGrowth: 4.5,
        jobs: 79,
      },
      {
        rank: 5,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Project Coordinator',
        avgSalary: 74249,
        salaryGrowth: 4.3,
        jobs: 38,
      },
      {
        rank: 6,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Executive Assistant',
        avgSalary: 83575,
        salaryGrowth: 3.8,
        jobs: 197,
      },
      {
        rank: 7,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Project Administrator',
        avgSalary: 69448,
        salaryGrowth: 3.8,
        jobs: 35,
      },
      {
        rank: 8,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Administration Manager',
        avgSalary: 76401,
        salaryGrowth: 3.8,
        jobs: 33,
      },
      {
        rank: 9,
        industryId: 6251,
        industryTitle: 'Administration & Office Support',
        roleTitle: 'Service Coordinator',
        avgSalary: 64075,
        salaryGrowth: 3.4,
        jobs: 41,
      },
    ],
  },
  {
    industryIdFilter: 1203,
    roles: [
      {
        rank: 1,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Banker',
        avgSalary: 70100,
        salaryGrowth: 6.3,
        jobs: 42,
      },
      {
        rank: 2,
        industryId: 1203,
        industryTitle: 'Banking & Financial Services',
        roleTitle: 'Financial Adviser',
        avgSalary: 102019,
        salaryGrowth: 3.6,
        jobs: 52,
      },
    ],
  },
  {
    industryIdFilter: 1204,
    roles: [
      {
        rank: 1,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Centre Operator',
        avgSalary: 58457,
        salaryGrowth: 9.4,
        jobs: 39,
      },
      {
        rank: 2,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Customer Experience Consultant',
        avgSalary: 59164,
        salaryGrowth: 4.9,
        jobs: 49,
      },
      {
        rank: 3,
        industryId: 1204,
        industryTitle: 'Call Centre & Customer Service',
        roleTitle: 'Customer Service Representative',
        avgSalary: 58205,
        salaryGrowth: 3.8,
        jobs: 362,
      },
    ],
  },
  {
    industryIdFilter: 6163,
    roles: [
      {
        rank: 1,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Coach',
        avgSalary: 64872,
        salaryGrowth: 11.4,
        jobs: 41,
      },
      {
        rank: 2,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Social Worker',
        avgSalary: 88048,
        salaryGrowth: 6.9,
        jobs: 179,
      },
      {
        rank: 3,
        industryId: 6163,
        industryTitle: 'Community Services & Development',
        roleTitle: 'Adviser',
        avgSalary: 100073,
        salaryGrowth: 3.8,
        jobs: 38,
      },
    ],
  },
  {
    industryIdFilter: 1206,
    roles: [
      {
        rank: 1,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Excavator Operator',
        avgSalary: 69922,
        salaryGrowth: 5.2,
        jobs: 36,
      },
      {
        rank: 2,
        industryId: 1206,
        industryTitle: 'Construction',
        roleTitle: 'Surveyor',
        avgSalary: 112419,
        salaryGrowth: 3.2,
        jobs: 128,
      },
    ],
  },
  {
    industryIdFilter: 6123,
    roles: [
      {
        rank: 1,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Centre Manager',
        avgSalary: 100173,
        salaryGrowth: 9,
        jobs: 87,
      },
      {
        rank: 2,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Librarian',
        avgSalary: 70470,
        salaryGrowth: 8.3,
        jobs: 44,
      },
      {
        rank: 3,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Lecturer',
        avgSalary: 95946,
        salaryGrowth: 4.8,
        jobs: 86,
      },
      {
        rank: 4,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Kaiako',
        avgSalary: 71563,
        salaryGrowth: 3.7,
        jobs: 89,
      },
      {
        rank: 5,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Teacher',
        avgSalary: 78142,
        salaryGrowth: 3.5,
        jobs: 344,
      },
      {
        rank: 6,
        industryId: 6123,
        industryTitle: 'Education & Training',
        roleTitle: 'Tutor',
        avgSalary: 69524,
        salaryGrowth: 3.1,
        jobs: 121,
      },
    ],
  },
  {
    industryIdFilter: 1209,
    roles: [
      {
        rank: 1,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Draftsperson',
        avgSalary: 86886,
        salaryGrowth: 9.2,
        jobs: 35,
      },
      {
        rank: 2,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Project Engineer',
        avgSalary: 119987,
        salaryGrowth: 9.1,
        jobs: 163,
      },
      {
        rank: 3,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Engineering Manager',
        avgSalary: 146784,
        salaryGrowth: 3.7,
        jobs: 34,
      },
      {
        rank: 4,
        industryId: 1209,
        industryTitle: 'Engineering',
        roleTitle: 'Design Engineer',
        avgSalary: 105449,
        salaryGrowth: 3.3,
        jobs: 112,
      },
    ],
  },
  {
    industryIdFilter: 6205,
    roles: [
      {
        rank: 1,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Animal Attendant',
        avgSalary: 52617,
        salaryGrowth: 12.5,
        jobs: 35,
      },
      {
        rank: 2,
        industryId: 6205,
        industryTitle: 'Farming, Animals & Conservation',
        roleTitle: 'Veterinarian',
        avgSalary: 116012,
        salaryGrowth: 3.1,
        jobs: 87,
      },
    ],
  },
  {
    industryIdFilter: 1211,
    roles: [
      {
        rank: 1,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Therapist',
        avgSalary: 90817,
        salaryGrowth: 9.1,
        jobs: 146,
      },
      {
        rank: 2,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Clinician',
        avgSalary: 89854,
        salaryGrowth: 7.8,
        jobs: 80,
      },
      {
        rank: 3,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Health Improvement Practitioner',
        avgSalary: 87460,
        salaryGrowth: 6.5,
        jobs: 44,
      },
      {
        rank: 4,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Nurse Manager',
        avgSalary: 112859,
        salaryGrowth: 6.3,
        jobs: 36,
      },
      {
        rank: 5,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Anaesthetic Technician',
        avgSalary: 98005,
        salaryGrowth: 6.1,
        jobs: 33,
      },
      {
        rank: 6,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'General Practitioner',
        avgSalary: 217399,
        salaryGrowth: 5.5,
        jobs: 236,
      },
      {
        rank: 7,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Social Worker',
        avgSalary: 85169,
        salaryGrowth: 5.3,
        jobs: 84,
      },
      {
        rank: 8,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Sonographer',
        avgSalary: 144507,
        salaryGrowth: 4.8,
        jobs: 67,
      },
      {
        rank: 9,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Nurse',
        avgSalary: 87657,
        salaryGrowth: 4.7,
        jobs: 894,
      },
      {
        rank: 10,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Healthcare Assistant',
        avgSalary: 57091,
        salaryGrowth: 4.4,
        jobs: 115,
      },
      {
        rank: 11,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Physiotherapist',
        avgSalary: 88917,
        salaryGrowth: 3.6,
        jobs: 243,
      },
      {
        rank: 12,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Pharmacy Technician',
        avgSalary: 61337,
        salaryGrowth: 3.6,
        jobs: 45,
      },
      {
        rank: 13,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Clinical Manager',
        avgSalary: 112290,
        salaryGrowth: 3.4,
        jobs: 35,
      },
      {
        rank: 14,
        industryId: 1211,
        industryTitle: 'Healthcare & Medical',
        roleTitle: 'Receptionist',
        avgSalary: 56331,
        salaryGrowth: 3.1,
        jobs: 300,
      },
    ],
  },
  {
    industryIdFilter: 1212,
    roles: [
      {
        rank: 1,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Restaurant Manager',
        avgSalary: 65755,
        salaryGrowth: 7.6,
        jobs: 156,
      },
      {
        rank: 2,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Venue Manager',
        avgSalary: 77143,
        salaryGrowth: 7.5,
        jobs: 43,
      },
      {
        rank: 3,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Bar Manager',
        avgSalary: 65080,
        salaryGrowth: 6.4,
        jobs: 46,
      },
      {
        rank: 4,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Room Attendant',
        avgSalary: 51199,
        salaryGrowth: 4.6,
        jobs: 42,
      },
      {
        rank: 5,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Guest Services Agent',
        avgSalary: 53598,
        salaryGrowth: 3.8,
        jobs: 53,
      },
      {
        rank: 6,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Food and Beverage Attendant',
        avgSalary: 52622,
        salaryGrowth: 3.7,
        jobs: 80,
      },
      {
        rank: 7,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Team Member',
        avgSalary: 48648,
        salaryGrowth: 3.5,
        jobs: 62,
      },
      {
        rank: 8,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Kitchen Assistant',
        avgSalary: 49956,
        salaryGrowth: 3.3,
        jobs: 83,
      },
      {
        rank: 9,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Cafe Manager',
        avgSalary: 62897,
        salaryGrowth: 3.1,
        jobs: 39,
      },
      {
        rank: 10,
        industryId: 1212,
        industryTitle: 'Hospitality & Tourism',
        roleTitle: 'Barista',
        avgSalary: 52457,
        salaryGrowth: 3.1,
        jobs: 120,
      },
    ],
  },
  {
    industryIdFilter: 1213,
    roles: [
      {
        rank: 1,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Partner',
        avgSalary: 124630,
        salaryGrowth: 6.5,
        jobs: 123,
      },
      {
        rank: 2,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'Recruitment Consultant',
        avgSalary: 82468,
        salaryGrowth: 5.2,
        jobs: 129,
      },
      {
        rank: 3,
        industryId: 1213,
        industryTitle: 'Human Resources & Recruitment',
        roleTitle: 'People and Culture Adviser',
        avgSalary: 94709,
        salaryGrowth: 5,
        jobs: 58,
      },
    ],
  },
  {
    industryIdFilter: 6281,
    roles: [
      {
        rank: 1,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Data Engineer',
        avgSalary: 131324,
        salaryGrowth: 8.8,
        jobs: 122,
      },
      {
        rank: 2,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Data Analyst',
        avgSalary: 98259,
        salaryGrowth: 8.7,
        jobs: 59,
      },
      {
        rank: 3,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Systems Administrator',
        avgSalary: 93094,
        salaryGrowth: 8.3,
        jobs: 48,
      },
      {
        rank: 4,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Technical Lead',
        avgSalary: 156541,
        salaryGrowth: 8.1,
        jobs: 51,
      },
      {
        rank: 5,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Solutions Architect',
        avgSalary: 165225,
        salaryGrowth: 7.7,
        jobs: 92,
      },
      {
        rank: 6,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Product Owner',
        avgSalary: 136995,
        salaryGrowth: 6.7,
        jobs: 57,
      },
      {
        rank: 7,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Business Analyst',
        avgSalary: 116990,
        salaryGrowth: 4.5,
        jobs: 238,
      },
      {
        rank: 8,
        industryId: 6281,
        industryTitle: 'Information & Communication Technology',
        roleTitle: 'Support Engineer',
        avgSalary: 74207,
        salaryGrowth: 4.3,
        jobs: 100,
      },
    ],
  },
  {
    industryIdFilter: 6092,
    roles: [
      {
        rank: 1,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Dispatcher',
        avgSalary: 71138,
        salaryGrowth: 9,
        jobs: 40,
      },
      {
        rank: 2,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Inventory Controller',
        avgSalary: 68720,
        salaryGrowth: 8.9,
        jobs: 37,
      },
      {
        rank: 3,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Processing Officer',
        avgSalary: 55129,
        salaryGrowth: 6.7,
        jobs: 58,
      },
      {
        rank: 4,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Process Worker',
        avgSalary: 53957,
        salaryGrowth: 5.6,
        jobs: 51,
      },
      {
        rank: 5,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Team Member',
        avgSalary: 57362,
        salaryGrowth: 4.5,
        jobs: 39,
      },
      {
        rank: 6,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Delivery Driver',
        avgSalary: 56389,
        salaryGrowth: 3.8,
        jobs: 177,
      },
      {
        rank: 7,
        industryId: 6092,
        industryTitle: 'Manufacturing, Transport & Logistics',
        roleTitle: 'Storeperson',
        avgSalary: 55799,
        salaryGrowth: 3.2,
        jobs: 356,
      },
    ],
  },
  {
    industryIdFilter: 1218,
    roles: [
      {
        rank: 1,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Marketing Executive',
        avgSalary: 80305,
        salaryGrowth: 7.8,
        jobs: 70,
      },
      {
        rank: 2,
        industryId: 1218,
        industryTitle: 'Marketing & Communications',
        roleTitle: 'Marketing Coordinator',
        avgSalary: 68734,
        salaryGrowth: 3.8,
        jobs: 119,
      },
    ],
  },
  {
    industryIdFilter: 1221,
    roles: [
      {
        rank: 1,
        industryId: 1221,
        industryTitle: 'Real Estate & Property',
        roleTitle: 'Property Manager',
        avgSalary: 74023,
        salaryGrowth: 4.3,
        jobs: 215,
      },
    ],
  },
  {
    industryIdFilter: 6043,
    roles: [
      {
        rank: 1,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Branch Manager',
        avgSalary: 83258,
        salaryGrowth: 10,
        jobs: 66,
      },
      {
        rank: 2,
        industryId: 6043,
        industryTitle: 'Retail & Consumer Products',
        roleTitle: 'Sales Consultant',
        avgSalary: 53509,
        salaryGrowth: 3.9,
        jobs: 134,
      },
    ],
  },
  {
    industryIdFilter: 6362,
    roles: [
      {
        rank: 1,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Salesperson',
        avgSalary: 84791,
        salaryGrowth: 16.4,
        jobs: 48,
      },
      {
        rank: 2,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Account Executive',
        avgSalary: 87048,
        salaryGrowth: 5.6,
        jobs: 54,
      },
      {
        rank: 3,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Coordinator',
        avgSalary: 64743,
        salaryGrowth: 5.4,
        jobs: 38,
      },
      {
        rank: 4,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Sales Engineer',
        avgSalary: 99318,
        salaryGrowth: 5,
        jobs: 34,
      },
      {
        rank: 5,
        industryId: 6362,
        industryTitle: 'Sales',
        roleTitle: 'Account Manager',
        avgSalary: 94432,
        salaryGrowth: 3.9,
        jobs: 548,
      },
    ],
  },
  {
    industryIdFilter: 1224,
    roles: [
      {
        rank: 1,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Lifeguard',
        avgSalary: 55713,
        salaryGrowth: 7.9,
        jobs: 67,
      },
      {
        rank: 2,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Coach',
        avgSalary: 62029,
        salaryGrowth: 6.4,
        jobs: 57,
      },
      {
        rank: 3,
        industryId: 1224,
        industryTitle: 'Sport & Recreation',
        roleTitle: 'Instructor',
        avgSalary: 57328,
        salaryGrowth: 6.3,
        jobs: 101,
      },
    ],
  },
  {
    industryIdFilter: 1225,
    roles: [
      {
        rank: 1,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Security Officer',
        avgSalary: 55799,
        salaryGrowth: 12.5,
        jobs: 51,
      },
      {
        rank: 2,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Maintenance Technician',
        avgSalary: 73101,
        salaryGrowth: 12.2,
        jobs: 63,
      },
      {
        rank: 3,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Detailer',
        avgSalary: 56636,
        salaryGrowth: 9.6,
        jobs: 36,
      },
      {
        rank: 4,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Caretaker',
        avgSalary: 58670,
        salaryGrowth: 8.4,
        jobs: 42,
      },
      {
        rank: 5,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Cabinet Maker',
        avgSalary: 71628,
        salaryGrowth: 7.3,
        jobs: 36,
      },
      {
        rank: 6,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Arborist',
        avgSalary: 68617,
        salaryGrowth: 6.9,
        jobs: 34,
      },
      {
        rank: 7,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Drainlayer',
        avgSalary: 77516,
        salaryGrowth: 6.6,
        jobs: 55,
      },
      {
        rank: 8,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Gardener',
        avgSalary: 58925,
        salaryGrowth: 6.5,
        jobs: 122,
      },
      {
        rank: 9,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Field Service Technician',
        avgSalary: 83766,
        salaryGrowth: 5.9,
        jobs: 77,
      },
      {
        rank: 10,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Machinist',
        avgSalary: 75254,
        salaryGrowth: 5.3,
        jobs: 35,
      },
      {
        rank: 11,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Technician',
        avgSalary: 70400,
        salaryGrowth: 3.9,
        jobs: 115,
      },
      {
        rank: 12,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Team Leader',
        avgSalary: 77033,
        salaryGrowth: 3.6,
        jobs: 31,
      },
      {
        rank: 13,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Labourer',
        avgSalary: 54984,
        salaryGrowth: 3.6,
        jobs: 133,
      },
      {
        rank: 14,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Service Technician',
        avgSalary: 76591,
        salaryGrowth: 3.5,
        jobs: 293,
      },
      {
        rank: 15,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Handyperson',
        avgSalary: 61462,
        salaryGrowth: 3.4,
        jobs: 51,
      },
      {
        rank: 16,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Serviceperson',
        avgSalary: 61029,
        salaryGrowth: 3.3,
        jobs: 42,
      },
      {
        rank: 17,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Baker',
        avgSalary: 57989,
        salaryGrowth: 3.3,
        jobs: 66,
      },
      {
        rank: 18,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Installer',
        avgSalary: 67656,
        salaryGrowth: 3.3,
        jobs: 162,
      },
      {
        rank: 19,
        industryId: 1225,
        industryTitle: 'Trades & Services',
        roleTitle: 'Automotive Technician',
        avgSalary: 72533,
        salaryGrowth: 3,
        jobs: 199,
      },
    ],
  },
];
